(function () {
/*
 * -----------------------------------------------------------------------------
 * POPUP CLOSE
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @kind component
 * @overview Closes dialogs on click events.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("popup-close") === undefined) {
    class popupClose extends HTMLElement {
        constructor(){
            super();
            this.popup = this.closest("popup-toggle");
            if (!this.popup) return;
            this.addEventListener("click", this.close);
        }
        close() {
            this.popup.close();
        }
    }
    customElements.define("popup-close", popupClose);
}



})();
